import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//Antd
import { Button, Form, Input, Modal, Select, Spin } from "antd";
//Ducks and Components
import * as ducks from "../../../redux/aspirante/reqAcademicoDuck";
import { ReqArchivo } from "./";
//Utils
import { REQUERIDO, TXT_ALFANUMERICO } from "../../../utils";
import { Ast, Label, NIV_SUPERIOR } from "../../../utils";
import * as func from "../../../utils";

const props = {
  showSearch: true,
  allowClear: true,
  optionFilterProp: "children",
  placeholder: "Selecciona una opción",
};

/**
 * Componente que muestra el modal de registro para capturar una nueva escolaridad
 * @param {boolean} isModalVisible para mostrar el modal
 * @param {function} showModal Para mostrar u ocultar el modal
 * @param {object} form Para manejar el estado del formulario, proviene del useForm
 * @returns JSX.Element Modal de registro
 */
export const ModalAcademico = ({ isModalVisible, showModal, form }) => {
  const dispatch = useDispatch();
  const [disable, setDisable] = useState(false);
  const [gradosAvance, setGradosAvance] = useState([]);

  const { idAspirante, correo } = useSelector((state) => state.usuarioLogin);
  const { nivelEstudios, areaAcademica, gradoAvance, docObtenido } =
    useSelector((state) => state.catalogos);

  const { loadingForm, isReqAcademico } = useSelector(
    (state) => state.reqAcademico
  );
  const { idEscolaridad, idNivEstudio, idArchivo, rutaArchivo } =
    isReqAcademico;

  useEffect(() => {
    if (idEscolaridad) {
      const idGrado = getIdGradoAvance(idNivEstudio);
      setDisable(String(idNivEstudio) !== NIV_SUPERIOR); //Se obtiene el idNivelEstudio
      //Se manda a filtrar el catalogo gradoAvance de acuerdo al id nivEstudio
      idGrado &&
        setGradosAvance(gradoAvance.filter(({ id }) => id === idGrado));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReqAcademico, idEscolaridad]);

  /**
   * Función que guarda la escolaridad en lista que se muestra en la pantalla
   */
  const saveForm = () => {
    form
      .validateFields()
      .then((values) => {
        const formData = createFormData(values);
        //Se manda el form data
        dispatch(ducks.saveReqAcademico(formData));
        dispatch(ducks.setExistenDatos(true));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  /**
   * Función que actualiza el requisito académico
   */
  const updateForm = () => {
    form
      .validateFields()
      .then((values) => {
        const json = { idEscolaridad, idArchivo, rutaArchivo, ...values };
        const formData = createFormData(json);
        dispatch(ducks.updateReqAcademico(formData));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const createFormData = (form) => {
    let formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (`${key}` === "archivo") {
        if (value?.file) {
          //Se realiza la creación de un new File ya que al iterarlo por defecto lo obtiene como string
          const file = func.blobToFile(value.file);
          //Se manda el archivo en la lista
          formData.append(`${key}`, file);
        } else {
          //Se manda vacio
          formData.append(`${key}`, new File([""], ""));
        }
      }
      if (`${key}` === "idArchivo" && value === null) {
        //Indica que no existe un documento en BD
        formData.append(`${key}`, -1);
      }
      //Se agregan los demás atributos
      formData.append(`${key}`, value);
    });
    formData.append(`id`, idAspirante);
    formData.append(`usuario`, correo);
    return formData;
  };

  /**
   * Oculta el modal y limpia el formulario
   */
  const onCancel = () => {
    form.resetFields();
    dispatch(ducks.isActiveReqAcademico({}));
    showModal();
  };

  /**
   * Función para validar si el campo del archivo es obligatorio
   * @param {event} e
   */
  const onChangeNivEstudio = (e) => {
    setDisable(e !== NIV_SUPERIOR); //Se obtiene el idNivelEstudio
    // //Se obtiene el idGradoAvance a partir del idNivelEstudio
    const idGrado = getIdGradoAvance(e);
    // //Se manda a filtrar el catalogo gradoAvance de acuerdo al id nivEstudio
    idGrado && setGradosAvance(gradoAvance.filter(({ id }) => id === idGrado));
    form.setFieldsValue({ grado: undefined }); //Se limpia el Select
  };

  /**
   * Función para recuperar el idGradoAvance
   * @param {number} idNivEstudio Id del nivel de estudio.
   * @returns IdGradoAvance
   */
  const getIdGradoAvance = (idNivEstudio) =>
    nivelEstudios.find(({ id }) => id === +idNivEstudio)?.idGradoAvance;

  return (
    <Modal
      // title={"Agregar nueva escolaridad"}
      title={idEscolaridad ? "Editar escolaridad" : "Agregar nueva escolaridad"}
      visible={isModalVisible}
      onCancel={onCancel}
      keyboard={false}
      maskClosable={false}
      width={400}
      footer={[
        <center key="guardar">
          {idEscolaridad ? (
            <Button type="primary" onClick={updateForm}>
              Modificar
            </Button>
          ) : (
            <Button type="primary" onClick={saveForm}>
              Guardar
            </Button>
          )}
        </center>,
      ]}
    >
      <Spin size="large" spinning={loadingForm}>
        <label className="requeridos">
          Los campos con ( <Ast />) son necesarios.
        </label>

        <Form form={form} layout="vertical" style={{ marginTop: 20 }}>
          <Form.Item
            label={<Label label={"Nivel de estudios"} isRequired />}
            name={"nivEstudio"}
            rules={REQUERIDO}
          >
            <Select
              {...props}
              onChange={onChangeNivEstudio}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {nivelEstudios.map(({ id, nombre }) => (
                <Select.Option key={id}>{nombre}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <SelectGeneric
            label={"Área académica"}
            name={"area"}
            array={areaAcademica}
          />

          <Form.Item
            label={<Label label={"Carrera"} isRequired={disable} />}
            name="carrera"
            rules={
              disable
                ? [...REQUERIDO, ...TXT_ALFANUMERICO]
                : [...TXT_ALFANUMERICO]
            }
          >
            <Input autoComplete="off" maxLength={100} />
          </Form.Item>

          <SelectGeneric
            label={"Grado de avance"}
            name={"grado"}
            array={gradosAvance}
          />

          <div className="caja-upload">
            <div className="caja-upload-content">
              <SelectGeneric
                label={"Documento obtenido"}
                name={"documento"}
                array={docObtenido}
              />
              <div style={{ fontSize: 12, fontWeight: 400 }}>
                <b>Nota:</b> Verifica que los documentos que ingreses sean
                legibles.
              </div>
              <ReqArchivo isRequired />
            </div>
          </div>
        </Form>
      </Spin>
    </Modal>
  );
};

/**
 * Componente generico para mostrar los select
 * @param {object} param0
 * @returns Select
 */
const SelectGeneric = ({ label, name, array }) => (
  <Form.Item
    label={<Label label={label} isRequired />}
    name={name}
    rules={REQUERIDO}
  >
    <Select
      {...props}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {array.map(({ id, nombre }) => (
        <Select.Option key={id}>{nombre}</Select.Option>
      ))}
    </Select>
  </Form.Item>
);
